import React from 'react';
import { Box, Stack, CircularProgress } from '@mui/material';
import FundOpportunity from '../models/FundOpportunity';
import BackendService from 'BackendService';
import { StyledTypography } from './styles/styles';
import { StyledInput } from './styles/StyledInputs';
import { StyledButton } from './styles/StyledButtons';

interface ShareItemProps {
  model: FundOpportunity;
  modelType: string;
  onClose: () => void;
}

interface ShareItemState {
  sharingItem: boolean;
  shareResult?: string;
  shareError?: string;
}

export default class ShareItem extends React.Component<ShareItemProps, ShareItemState> {
  constructor(props: ShareItemProps) {
    super(props);
    this.state = {
      sharingItem: false,
    };
  }

  submitShare = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const firstName = (form.elements.namedItem('first_name') as HTMLInputElement).value;
    const email = (form.elements.namedItem('email') as HTMLInputElement).value;

    if (!firstName || !email) {
      this.setState({
        shareResult: 'Please enter a name and email address',
        shareError: 'missing',
      });
      return;
    }

    this.setState({
      sharingItem: true,
      shareResult: undefined,
      shareError: undefined,
    });

    new BackendService()
      .shareItem(this.props.model.id, this.props.modelType, firstName, email)
      .then(() => {
        this.setState({
          sharingItem: false,
          shareResult: 'Item shared successfully',
          shareError: undefined,
        });
      })
      .catch(() => {
        this.setState({
          sharingItem: false,
          shareResult:
            'Unable to share item. Please try again later. Or contact support@fidescapital.com.au if problem persists.',
          shareError: 'error',
        });
      });
  };

  render() {
    const { sharingItem, shareResult, shareError } = this.state;

    return (
      <Stack spacing={3}>
        <StyledTypography variant="h6">Share Opportunity</StyledTypography>

        <StyledTypography variant="body2">
          To share <strong>{this.props.model.summaryTitle}</strong> with someone, please enter their
          name and email address below.
        </StyledTypography>

        <Box component="form" onSubmit={this.submitShare}>
          <Stack spacing={2}>
            <StyledInput
              name="first_name"
              label="First Name"
              required
              fullWidth
              slotProps={{ inputLabel: { shrink: true } }}
            />
            <StyledInput
              name="email"
              label="Email"
              required
              fullWidth
              type="email"
              slotProps={{ inputLabel: { shrink: true } }}
            />

            {!shareResult && (
              <Stack direction="row" spacing={2}>
                <StyledButton type="submit">
                  {sharingItem && <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />}
                  Share
                </StyledButton>

                <StyledButton
                  buttonVariant="inactiveOrCancel"
                  type="button"
                  onClick={this.props.onClose}
                >
                  Cancel
                </StyledButton>
              </Stack>
            )}

            {shareResult && (
              <StyledTypography variant="body2" tone={shareError ? 'danger' : 'tone1'}>
                {shareResult}
              </StyledTypography>
            )}
          </Stack>
        </Box>
      </Stack>
    );
  }
}
